/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Wb_NInputs */

const en_tut_wb_n = /** @type {(inputs: Tut_Wb_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permissions follow the parent: a board on a finished meeting becomes read-only, and a board on an office area can only be edited by people currently standing in that area. Per board: 500 objects, 500 arrows, 20 people, 10 restore points.`)
};

const id_tut_wb_n = /** @type {(inputs: Tut_Wb_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izinnya mengikuti induknya: papan milik rapat yang sudah berakhir jadi hanya-baca, dan papan milik area kantor hanya bisa disunting oleh orang yang sedang berada di area itu. Batas per papan: 500 objek, 500 panah, 20 orang, 10 titik simpan.`)
};

/**
* | output |
* | --- |
* | "Permissions follow the parent: a board on a finished meeting becomes read-only, and a board on an office area can only be edited by people currently standing..." |
*
* @param {Tut_Wb_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_wb_n = /** @type {((inputs?: Tut_Wb_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Wb_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_wb_n(inputs)
	return en_tut_wb_n(inputs)
});